$(function() {
  // iOS Safari で下のブラウザー・ナビゲーション・バーが出るため
  // vhをバーがかぶれてない部分の高さに設定する

  function refreshVh() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
  }

  window.addEventListener('resize', refreshVh);
  refreshVh();

  var menu = {
    dashIsOpen: false,
    searchIsOpen: false,
    searchIsFocused: false,
    buttons: {
      hamburger: $('.global-menu__button--burger'),
      glass: $('.global-menu__button--glass'),
      input: $('.global-menu__input-field'),
      inputGo: $('.global-menu__input-button--go'),
      inputBack: $('.global-menu__input-button--back'),
      translate: $('.global-menu__sns-item--translate'),
      translateClose: $('.translation__close'),
      translateIcon: $('.global-menu__button--translate'),
    },
    rotation: {
      interval: undefined,
      clear: function() {
        clearInterval(this.interval);
        this.interval = undefined;
      },
      start: function() {
        this.interval = setInterval(function() {
          this.cycle('.global-menu__input-button:first-child .icon', this.icons);
        }.bind(this), 1500);
      },
      icons: [
        'cupcake', // 食べる 🎂
        'rocket', // ニュース 🚀
        'home-variant', // 泊まる 🏠
        'ring', // 美容・健康 💍
        'barley', // 医療・福祉　🌿
        'cart', // 買い物 🛒
        'clover', // 生活 🍀
        'airballoon', // 遊ぶ 🎈
        'lightbulb-on', // 学ぶ 💡
      ],
      current: 0,
      cycle: function(iconContainer, iconArray) {
        var iconArrayLength = iconArray.length - 1;
        $(iconContainer).fadeOut().promise().done(function(event) {
          menu.rotation.current >= iconArrayLength ? menu.rotation.current = 0 : menu.rotation.current += 1;
          $(this).attr('class', 'icon icon-' + iconArray[menu.rotation.current]).fadeIn();
        });
      } // cycle
    } // rotation
  } // menu


  /**
   * For fading from an existing icon to a newly specified icon
   * @event
   * @param {string} el - css class to search with jQuery
   * @param {string} icon - material icon name; 'none' does not fade back
   */
  function fadeToIcon(el, icon) {
    if (icon === 'none') {
      el.find('.icon')
        .fadeTo('fast', 0)
      return;
    } else {
      el.find('.icon')
        .fadeTo('fast', 0)
        .promise()
        .then(function() {
          $(this)
            .attr('class', 'icon icon-' + icon)
            .fadeTo('fast', 1)
        })
    }
  }

  /**
   *
   * @param {string} clickedElement
   */
  function updateButtonStatus(clickedElement) {
    var genreMenu = $('.global-menu__genre');
    var openParent = $('body');
    var openClass = 'menu-is-open';
    console.log('clicked', menu);

    if (
      clickedElement.currentTarget === menu.buttons.translate[0] ||
      clickedElement.currentTarget === menu.buttons.translateIcon[0]
    ) {
      $('.translation__area').fadeIn();
    } else if (clickedElement.currentTarget === menu.buttons.translateClose[0]) {
      $('.translation__area').fadeOut();
    }

    // -------------------------------------------------------------------------
    // メニューはすでに開いていたら...
    // -------------------------------------------------------------------------
    if (menu.dashIsOpen) {
      // そして、「☰」・「×」ボタンが押さえれたら...
      if (clickedElement.currentTarget === menu.buttons.hamburger[0]) {
        menu.dashIsOpen = false; // メニュー状態を設定する（開いてない）
        menu.searchIsOpen = false;
        menu.searchIsFocused = false;
        menu.rotation.clear(); // ジャンルアイコンのアニメーションを止める
        openParent.toggleClass(openClass);
        fadeToIcon(menu.buttons.hamburger, 'menu'); // 「×」から「☰」に切り替え
        fadeToIcon(menu.buttons.glass, 'magnify'); // 透明から「🔍」に戻る
        genreMenu.fadeOut();
        return; // この条件分と関数から飛び出す！（終了）
      }

      if (clickedElement.currentTarget === menu.buttons.inputBack[0]) {
        if (menu.searchIsOpen) {
          menu.searchIsOpen = false;
          fadeToIcon(menu.buttons.inputBack, 'asterisk');
          menu.rotation.start(); // ジャンルアイコンのアニメーションを開始
          genreMenu.fadeOut();
          return;
        } else {
          menu.searchIsOpen = true;
          menu.rotation.clear();
          genreMenu.fadeIn();
          fadeToIcon(menu.buttons.inputBack, 'keyboard-return');
          return;
        }
      }

      if (clickedElement.currentTarget === menu.buttons.input[0]) {
        clickedElement.type === 'focus' ?
          menu.searchIsFocused = true :
          menu.searchIsFocused = false;

        if (!menu.searchIsOpen) {
          menu.searchIsOpen = true;
          menu.rotation.clear();
          genreMenu.fadeIn();
          fadeToIcon(menu.buttons.inputBack, 'keyboard-return');
          return;
        }
      }
    }

    // -------------------------------------------------------------------------
    // メニューは開いてない場合は...
    // -------------------------------------------------------------------------
    if (!menu.dashIsOpen) {
      // そして、「☰」・「×」ボタンが押さえれたら...
      if (clickedElement.currentTarget === menu.buttons.hamburger[0]) {
        menu.dashIsOpen = true;
        openParent.toggleClass(openClass);
        menu.rotation.start(); // ジャンルアイコンのアニメーションを開始
        fadeToIcon(menu.buttons.hamburger, 'close'); // 「☰」から「×」に切り替え
        fadeToIcon(menu.buttons.glass, 'none'); // 「🔍」を隠す
        return;
      }

      if (clickedElement.currentTarget === menu.buttons.glass[0]) {
        menu.dashIsOpen = true;
        menu.searchIsOpen = true;
        menu.rotation.clear();
        openParent.toggleClass(openClass);
        fadeToIcon(menu.buttons.hamburger, 'close');
        fadeToIcon(menu.buttons.glass, 'none');
        fadeToIcon(menu.buttons.inputBack, 'keyboard-return');
        genreMenu.fadeIn();
        menu.buttons.input.focus();
        return;
      }
    }
  }

  menu.buttons.hamburger.on('click', updateButtonStatus);
  menu.buttons.glass.on('click', updateButtonStatus);
  menu.buttons.inputBack.on('click', updateButtonStatus);
  menu.buttons.input.on('focus blur', updateButtonStatus);
  menu.buttons.translate.on('click', updateButtonStatus);
  menu.buttons.translateClose.on('click', updateButtonStatus);
  menu.buttons.translateIcon.on('click', updateButtonStatus);
});
